import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DateSelectionDropDown from './DateSelectionDropDown'
import RadioGroup from './RadioGroup'

import { requestShipAvailableDates } from '../../../actions/availableDates'
import 'react-dates/initialize'
import '../../../styles/scss/components/equote-react-dates-overrides.scss'

import loadingIcon from '../../../assets/icons/brand-loader-final.gif'

function DateSelection({
  datesAreFlexible,
  sailDate,
  selectedDate,
  getCalendar,
  availableSailingDates: { dates, isLoading, error }
}) {
  useEffect(() => {
    if (datesAreFlexible === 'Yes' && !dates) {
      getCalendar()
    }
  }, [getCalendar, dates, datesAreFlexible])
  return (
    <div className="equote-package-additional-details-form--departure">
      <div className="equote-package-additional-details-form--input-group equote-package-additional-details-form--departure--date-flexibility">
        <label className="equote-package-additional-details-form--input-group--label">
          DATES
        </label>
        <div className="equote-package-additional-details-form--departure-container">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap'
            }}
          >
            <span style={{ paddingRight: '45px' }}>
              Are your dates flexible?
            </span>
            <div>
              <RadioGroup
                options={[
                  {
                    label: 'Yes',
                    value: 'Yes'
                  },
                  {
                    label: 'No',
                    value: 'No'
                  }
                ]}
                name="Dates are flexible"
                displayFlex
                isRadio
              />
            </div>
          </div>
          {datesAreFlexible === 'Yes' && isLoading && (
            <div className="u-flex-container">
              <img src={loadingIcon} alt="loading" />
              Searching available dates...
            </div>
          )}
          {datesAreFlexible === 'Yes' && dates && (
            <div>
              <DateSelectionDropDown
                sailDate={sailDate}
                selectedDate={selectedDate}
                availableDates={dates}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ availableSailingDates }) => ({
  availableSailingDates: availableSailingDates
})
const mapDispatchToProps = dispatch => ({
  getCalendar() {
    dispatch(requestShipAvailableDates())
  }
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DateSelection)
